module.exports = __webpack_public_path__ + "img/title.c9f3a61f.png";